import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LogoutReason } from "../../app-auth/common/common.types";
import * as i0 from "@angular/core";
import * as i1 from "../../app-auth/services/auth-provider.service";
var ErrorInterceptor = /** @class */ (function () {
    function ErrorInterceptor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    ErrorInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).pipe(catchError(function (response) {
            if (response.status === 401 || response.error.error === '401') {
                // auto logout if 401 response returned from api
                if (_this.authenticationService.isAuthenticated()) {
                    _this.authenticationService.logout(LogoutReason.Automatic);
                }
            }
            var error = response.error.error_description || response.error.ExceptionMessage || response.statusText;
            return throwError(error);
        }));
    };
    ErrorInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErrorInterceptor_Factory() { return new ErrorInterceptor(i0.ɵɵinject(i1.AuthProviderService)); }, token: ErrorInterceptor, providedIn: "root" });
    return ErrorInterceptor;
}());
export { ErrorInterceptor };
export var errorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
};
